<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">

      <v-container>

        <v-expansion-panels
          v-model="panel"
          multiple expanded>
          <v-expansion-panel :key="0" class="ma-2 rounded-border">
            <v-expansion-panel-header class="titulo">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-cash</v-icon>
                <h2 class="text-h6 primary--text">Dados da Empresa</h2>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Seção 1: Dados do Comprador -->
              <div class="mb-6">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      label="Razão Social" 
                      v-model="item.razaoSocial" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>  
                  <v-col cols="12" md="6">
                    <v-text-field 
                      label="Nome Fantasia" 
                      v-model="item.nomeFantasia" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field 
                      :label="labelCnpj"
                      v-model="item.cnpj" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Atividade Econômica"
                      v-model="item.descricaoAtividadeEconomica"
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Situação"
                      v-model="item.descricaoStatus"
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>  
                  <v-col cols="12" md="12">
                    <v-textarea
                      label="Descrição da Empresa"
                      v-model="item.descricao"
                      dense
                      readonly
                      rows="2"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>          
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="1" class="ma-2 rounded-border">
            <v-expansion-panel-header class="titulo">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-card-account-mail</v-icon>
                <h2 class="text-h6 primary--text">Contato, Localização</h2>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Seção 3: Contato/Localização -->
              <div>
                <v-row>
                  <!-- Coluna 1: Contato  -->
                  <v-col cols="12" md="12">
                    <h3 class="text-subtitle-1 primary--text">CONTATO</h3>
                  </v-col>            
                  <v-col cols="12" md="4">
                    <v-text-field 
                      label="Email" 
                      v-model="item.email" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>            
                  <v-col cols="12" md="4">
                    <v-text-field 
                      label="Telefone/Celular" 
                      v-model="item.telefone" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field 
                      label="Site/Redes Sociais" 
                      v-model="item.siteRede" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <!-- Coluna 2: Endereço -->
                  <v-col cols="12" md="12">
                    <h3 class="text-subtitle-1 primary--text">ENDEREÇO</h3>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field 
                      :label="labelCep"
                      v-model="item.cep" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field 
                      label="Cidade" 
                      v-model="item.cidade" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field 
                      :label="labelEstado"
                      v-model="item.estado" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="empresaEstrangeira" cols="12" md="3">
                    <v-text-field
                      label="País"
                      v-model="item.pais"
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" :md="empresaEstrangeira ? 4 : 3">
                    <v-text-field 
                      :label="labelBairro"
                      v-model="item.bairro" 
                      dense
                      readonly
                    ></v-text-field>              
                  </v-col>
                  <v-col cols="12" :md="empresaEstrangeira ? 4 : 6">
                    <v-text-field 
                      :label="labelEndereco"
                      v-model="item.endereco" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" :md="empresaEstrangeira ? 4 : 6">
                    <v-text-field 
                      :label="labelComplemento"
                      v-model="item.complemento" 
                      dense
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>          
          <v-expansion-panel :key="2" class="ma-2 rounded-border">
            <v-expansion-panel-header class="titulo">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
                <h2 class="text-h6 primary--text">Responsáveis</h2>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Seção 4: Responsáveis -->
              <div>
                <v-row>        
                  <v-col cols="12" md="12">
                    <v-data-table
                      :headers="headersResponsaveis"
                      :items="item.contatos"
                      hide-default-footer
                      disable-sort
                      dense
                      class="elevation-0"
                    >
                      <template v-slot:no-data>
                        <v-alert type="info" dense class="ma-2">Nenhum responsável cadastrado.</v-alert>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>          
        </v-expansion-panels>

      </v-container>
  
    </v-card-text>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>    
</v-dialog>
</template>

<script>
export default {
  name: "DetalheCompradorDialog",
  props: ['value','item'],
  data () {
    return {
      formValid: false,
      loading: false,
      panel: [0,1,2],
      headersResponsaveis: [
        { text: "Nome", value: "nome", class: "blue darken-2 white--text" },
        { text: "Cargo", value: "cargo", class: "blue darken-2 white--text" },
        { text: "Email", value: "email", class: "blue darken-2 white--text" },
        { text: "Telefone", value: "telefone", class: "blue darken-2 white--text" },
        { text: "Celular", value: "celular", class: "blue darken-2 white--text" },
      ],
    }
  },
  computed: {
    getTitle() {
      return 'Detalhes do Comprador'
    },
    empresaEstrangeira() {
      return this.item?.flgEmpresaEstrangeira === 'S';
    },
    labelCnpj() {
      return this.empresaEstrangeira ? 'Registro da empresa estrangeira' : 'CNPJ';
    },
    labelCep() {
      return this.empresaEstrangeira ? 'Código postal' : 'CEP';
    },
    labelEstado() {
      return this.empresaEstrangeira ? 'Estado/Província/Região' : 'Estado';
    },
    labelBairro() {
      return this.empresaEstrangeira ? 'Linha de endereço 1 (Bairro)' : 'Bairro';
    },
    labelEndereco() {
      return this.empresaEstrangeira ? 'Linha de endereço 2 (Endereço)' : 'Endereço';
    },
    labelComplemento() {
      return this.empresaEstrangeira ? 'Caixa postal / complemento' : 'Complemento';
    }
  },
  methods: {

  },
}
</script>

<style scoped>

</style>